// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__3u9mZ","checkboxCol":"Table_checkboxCol__2iMcp","emailCol":"Table_emailCol__1SWDx","actionCol":"Table_actionCol__byFNK"};